<div class="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50 bg-primary p-2 rounded-full cursor-pointer w-12 h-12"
    data-cc="show-preferencesModal">
    <svg 
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="w-full h-full">
        <g id="SVGRepo_bgCarrier"stroke-width="0"></g>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
            <path 
                d="M9 16H9.01M12 11H12.01M7 10H7.01M15 16H15.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C12 5.76142 13.7909 8 16 8C16 10.2091 18.2386 12 21 12Z"
                [attr.stroke]="tpl.merchantColors ? tpl.merchantColors.textOnPrimary600 : '#00ffff'"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round">
            </path>
        </g>
    </svg>
</div>

